import { Col, Form, Row, Space } from "antd";
import CampaignInfo from "../components/CampaignInfo";
import ButtonGroup from "../components/ButtonGroup";
import CashDiscountInfo from "../components/CashDiscountInfo";

const CashDiscountForm = ({
  handleValuesChange,
  isApplyWithPromotion,
  handleCheckIsApplyWithPromo,
  form,
  loadingCheckDuplicateCodes,
  dataConfirmModal,
  visibleConfirmModal,
  handleOpenConfirmModal,
  handleCancelConfirmModal,
  handleActionCampaign,
  createLoading,
  isUpdate,
  isEditMode,
  loadingUpdate,
  initialValues,
}) => {
  return (
    <Form
      layout="vertical"
      colon={false}
      form={form}
      initialValues={initialValues}
      onValuesChange={handleValuesChange}
      style={{ minHeight: "calc(100vh - 220px)", display: "flex", flexDirection: "column" }}
    >
      <Space direction="vertical" style={{ width: "100%", flex: 1 }} className="custom-collapse">
        <Row gutter={[16, 8]}>
          <Col span={12}>
            <CampaignInfo
              form={form}
              isApplyWithPromotion={isApplyWithPromotion}
              handleCheckIsApplyWithPromo={handleCheckIsApplyWithPromo}
              isUpdate={isUpdate}
            />
          </Col>
          <Col span={12}>
            <CashDiscountInfo form={form} />
          </Col>
        </Row>
        {/* <OneOnProductForm form={form} isUpdate={isUpdate} dataTiersServer={dataDiscountProduct} /> */}
      </Space>
      <ButtonGroup
        form={form}
        loadingCheckDuplicateCodes={loadingCheckDuplicateCodes}
        data={dataConfirmModal}
        visibleConfirmModal={visibleConfirmModal}
        handleOpenConfirmModal={handleOpenConfirmModal}
        handleCancelConfirmModal={handleCancelConfirmModal}
        handleActionCampaign={handleActionCampaign}
        createLoading={createLoading || loadingUpdate}
        isEditMode={isEditMode}
      />
    </Form>
  );
};

export default CashDiscountForm;
